const apiUrl = "https://mavitracker.mooo.com"

export default apiUrl;
